import { SxProps } from '@mui/material';

export enum HelperTextType {
  Normal,
  Error,
}

// INTERFACES
export interface InputProps {
  children: React.ReactElement;
  label?: string;
  helperText?: string;
  helperTextType?: HelperTextType;
  sx?: SxProps;
}
